// extracted by mini-css-extract-plugin
export default {"add-user-form":"AddUser_add-user-form__zMC7b","form-header":"AddUser_form-header__slBpe"};